import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { from, Observable, of, OperatorFunction } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { MalihuScrollbarDirective } from 'ngx-malihu-scrollbar';
import { GlobalConfig } from 'src/app/core/config.model';
import { ajaxCall, DataTablesResponse } from 'src/app/core/services/ajax-call.service';
import { EntityInformation } from '../models/entity-information.model';
import { EntitySummary } from '../models/entity-summary.model';
import { EntityTreeInformation } from '../models/entity-tree-information.model';
import { OrdinalPipe } from 'src/app/core/pipes.model';
import { NgForm } from '@angular/forms';
import { NgbNav, NgbDropdown, NgbNavChangeEvent, NgbTypeaheadSelectItemEvent, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { SearchStatus } from 'src/app/core/lazy-load/search-status.model';
import { first } from 'rxjs/operators';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { FocusMeDirective } from 'src/app/core/focus-me/focus-me.directive';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { EntityHeaderInformation } from '../models/entity-header-information.model';
import { ListFilter } from 'src/app/core/list-filter.model';
import { RouterExtService } from 'src/app/core/services/router-ext.service';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { EntityAssignmentInformation, SecondaryEntityInformation } from '../models/entity-assignment-information.model';
import { UserInformation } from 'src/app/core/user-properties/user-information.model';
import { PDxUserPermission } from 'src/app/core/PDxUserPermission.enum';
import { CloneService } from 'src/app/core/services/clone.service';
import { EntityImportComponent } from '../entity-import/entity-import.component';

@Component({
  selector: 'app-entity-tree',
  templateUrl: './entity-tree.component.html',
  styles: [
  ]
})
export class EntityTreeComponent implements OnInit {

  launchStatuses: PDxListItem<boolean>[] = [
    { value: null, text: 'Any' },
    { value: true, text: 'Launched' },
    { value: false, text: 'Not launched' }
  ];
  entityStatuses: PDxListItem<boolean>[] = [
    { value: null, text: 'Any' },
    { value: true, text: 'Active' },
    { value: false, text: 'Deactivated' }
  ];
  searchEntityFilter: IntreeAccountSearchFilter = new IntreeAccountSearchFilter();
  searchAccountFilter: IntreeAccountSearchFilter = new IntreeAccountSearchFilter();
  entityList: EntityTreeInformation[] = [];
  columnFilters: IntreeEntityFilter[] = [];
  accountList: EntitySummary[] = [];
  newAccount: NewAccountInfo = null;
  nav: NgbNav;
  inSearch: boolean = false;
  stateList = PDxLists.AbbreviatedStates();
  loadStatus: SearchStatus = new SearchStatus(25);
  scrollbarOptions = GlobalConfig.scrollbarOptions;

  filterCount: number = 0;
  treeVendors: PDxListItem<string>[] = [];
  vendorTreeSelectOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.treeVendors = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Vendor/DropDownList', { query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.treeVendors = data;
            if (this.treeVendors.filter(v => v.value == this.searchEntityFilter.vendorId).length == 0) {
              this.searchEntityFilter.vendorId = null;
              this.setTreeFlags();
            }
          }
        }, () => { });
      } else {
        this.searchEntityFilter.vendorId = null;
        this.setTreeFlags();
      }
      return false;
    },
    onChange: (event, inst) => {
      this.setTreeFlags();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.searchEntityFilter.vendorId = null;
        this.setTreeFlags();
      }
    }]
  };
  setTreeFlags(): void {
    this.entityList.forEach(e => {
      e.children.forEach(c => {
        if (this.searchEntityFilter.vendorId) {
          c.hasBill = false;
          c.hasFormulary = false;
          c.hasMaster = c.masterFiles.filter(v => v == this.searchEntityFilter.vendorId).length > 0;
          c.hasShip = false;
          c.hasUser = false;
          c.hasVendor = c.vendors.filter(v => v == this.searchEntityFilter.vendorId).length > 0;
        } else {
          c.hasBill = false;
          c.hasFormulary = false;
          c.hasMaster = c.masterFiles.length > 0;
          c.hasShip = false;
          c.hasUser = false;
          c.hasVendor = c.vendors.length > 0;
        }
        c.hasIcons = c.hasBill || c.hasFormulary || c.hasMaster || c.hasShip || c.hasUser || c.hasVendor;
      });
    });
  }
  searchAccounts: PDxListItem<string>[] = [];
  accountSearchSelectOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.searchAccounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.searchAccounts = data;
            if (this.treeVendors.filter(v => v.value == this.searchFilter.accountId).length == 0) {
              this.searchFilter.accountId = null;
            }
          }
        }, () => { });
      } else {
        this.searchFilter.accountId = null;
      }
      return false;
    },
    onChange: (event, inst) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.searchFilter.accountId = null;
      }
    }],
  };
  searchVendors: PDxListItem<string>[] = [];
  vendorSearchSelectOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.searchVendors = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Vendor/DropDownList', { query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.searchVendors = data;
            if (this.searchVendors.filter(v => v.value == this.searchFilter.vendorId).length == 0) {
              this.searchFilter.vendorId = null;
            }
          }
        }, () => { });
      } else {
        this.searchFilter.vendorId = null;
      }
      return false;
    },
    onChange: (event, inst) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.searchFilter.vendorId = null;
      }
    }],
  };
  activeTab: string = 'tree';

  constructor(@Inject(DOCUMENT) private document: Document,
    private ajax: ajaxCall,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private modalService: NgbModal,
    private confirmService: ConfirmService,
    private dirtyService: DirtyTrackingService,
    private cloneService: CloneService,
    private routerExtService: RouterExtService) {
    this.searchEntityFilter.entityStatus = this.entityStatuses.filter(x => x.value === true)[0];
    this.searchEntityFilter.launchStatus = this.launchStatuses[0];
    this.searchAccountFilter.entityStatus = this.entityStatuses.filter(x => x.value === true)[0];
    this.searchAccountFilter.launchStatus = this.launchStatuses[0];
  }

  ngAfterViewInit() {
    //    this.mScrollbarService.initScrollbar('.entity-list', GlobalConfig.scrollbarOptions);
    //    this.mScrollbarService.initScrollbar('.entity-form', GlobalConfig.scrollbarOptions);
  }

  ngOnDestroy() {
    //    this.mScrollbarService.destroy('.entity-list');
    //    this.mScrollbarService.destroy('.entity-form');
    this.document.body.classList.remove('overlay-open');
  }

  selectionPath: string[] = [];
  ngOnInit(): void {
    this.document.body.classList.add('overlay-open');

    this.route.url.pipe(first()).subscribe((segments: UrlSegment[]) => {
      this.selectionPath = segments.map((s) => s.path);
      if (this.selectionPath.length > 0) {
        this.selectEntity(this.selectionPath[0], 0);
      }
      //segments.forEach((s, i) => { this.selectEntity(s.path, i, false); })
    });
    this.loadList(true);

    this.resetSearchFilters();
  }

  close(): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.routerExtService.closeOverlay();
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    if (!this.dirtyService.isClean()) {
      changeEvent.preventDefault();
    }
    this.newAccount = null;
  }

  searchColumn(idx: number): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.newAccount = null;
    this.columnFilters[idx].inSearch = true;
  }

  cancelColumnSearch(idx: number): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.newAccount = null;
    this.columnFilters[idx].inSearch = false;
    this.columnFilters[idx].searchText = null;
  }

  doSearch(): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.newAccount = null;
    this.inSearch = true;
  }

  cancelSearch(): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.newAccount = null;
    this.inSearch = false;
    this.searchAccountFilter.accountName = null;
    this.changeSearchFilter(true);
  }

  doImport(): void {
    const modal = this.modalService.open(EntityImportComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.result.then(() => {
      this.loadList(true);
    }, () => { });
  }

  doAdd(parentId: string): void {
    if (this.assignment) {
      return;
    }
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.newAccount = null;
    setTimeout(() => {
      this.newAccount = { parentId: parentId, entityId: null };
    }, 10);
  }

  loadList(reset: boolean): void {
    if (this.loadStatus.isInLoad()) {
      return;
    }
    if (reset) {
      this.loadStatus.reset();
      this.accountList = [];
    }
    if (!this.loadStatus.hasMore()) {
      return;
    }
    this.loadStatus.startLoad();
    if (reset) {
      this.ajax.MakeCall<EntitySummary[]>('/Entity/FullList', { searchFilter: this.searchAccountFilter, loadStatus: this.loadStatus }).then((data) => {
        this.accountList = data;
        this.loadStatus.setLast(data.length);
      }, () => { });

    } else {
      this.ajax.MakeCall<EntitySummary[]>('/Entity/FullList', { searchFilter: this.searchAccountFilter, loadStatus: this.loadStatus }, false).then((data) => {
        data.forEach((x) => { this.accountList.push(x); });
        this.loadStatus.setLast(data.length);
      }, () => { });

    }
  };

  cancelAccountCallback = (): void => {
    this.newAccount = null;
  }

  saveAccountCallback = (): void => {
    if (this.newAccount.parentId) {
      this.refreshEntities(this.newAccount.parentId);
    } else {
      this.loadList(true);
    }
    this.newAccount = null;
  }

  private filterTimeout: NodeJS.Timeout;
  changeSearchFilter(now: boolean): void {
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }

    if (now) {
      this.loadList(true);
    } else {
      this.filterTimeout = setTimeout(() => { this.loadList(true); }, 500);
    }
  }

  hasEntitySearch(): boolean {
    return (this.columnFilters.filter((x) => { return x.inSearch && (x.searchText); }).length > 0) ||
      (this.searchEntityFilter.launchStatus.value !== null) ||
      (this.searchEntityFilter.entityStatus.value !== null) ||
      (this.searchEntityFilter.vendorId !== null) ||
      (this.searchEntityFilter.hasMaster) ||
      (this.searchEntityFilter.hasFormulary) ||
      (this.searchEntityFilter.hasVendor) ||
      (this.searchEntityFilter.hasBill) ||
      (this.searchEntityFilter.hasShip) ||
      (this.searchEntityFilter.hasUser);
  }

  entityItemClass(entity: EntitySummary, col: number): string {
    var c = '';
    if ((col + 1 < this.entityList.length) && (this.entityList[col + 1].entityId == entity.entityId)) {
      c += 'active ';
      if (this.assignment && this.assignment.entityId == entity.entityId) {
        c += 'user-assign ';
      }
    }
    if (!entity.isActive) {
      c += 'deactivated ';
    } else if (!entity.isLaunched) {
      c += 'not-launched ';
    }

    if (this.hasEntitySearch()) {
      var s = ' search-result';
      if (this.columnFilters[col].inSearch && (this.columnFilters[col].searchText)) {
        this.columnFilters[col].searchText.split(' ').forEach((x) => {
          if ((entity.name.search(new RegExp(x, "i")) == -1) &&
            (entity.fullAddress.search(new RegExp(x, "i")) == -1) &&
            (entity.pdxIdentifier.search(new RegExp(x, "i")) == -1)) {
            s = '';
          }
        });
      } else if ((this.columnFilters.filter((x) => { return x.inSearch && (x.searchText); }).length > 0)) {
        s = ''; // any column is being searched, but not this one - clear it
      }
      if (this.searchEntityFilter.launchStatus.value !== null) {
        if (this.searchEntityFilter.launchStatus.value != entity.isLaunched) {
          s = '';
        }
      }
      if (this.searchEntityFilter.entityStatus.value !== null) {
        if (this.searchEntityFilter.entityStatus.value != entity.isActive) {
          s = '';
        }
      }
      if (this.searchEntityFilter.hasMaster) {
        if (!entity.hasMaster) {
          s = '';
        }
      }
      if (this.searchEntityFilter.hasFormulary) {
        if (false) {
          s = '';
        }
      }
      if (this.searchEntityFilter.hasVendor || (this.searchEntityFilter.vendorId !== null)) {
        if (!entity.hasVendor) {
          s = '';
        }
      }
      if (this.searchEntityFilter.hasBill) {
        if (false) {
          s = '';
        }
      }
      if (this.searchEntityFilter.hasShip) {
        if (false) {
          s = '';
        }
      }
      if (this.searchEntityFilter.hasUser) {
        if (!entity.hasUser) {
          s = '';
        }
      }
      c += s;
    }

    return c;
  }

  manageEntity(entityId: string): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.router.navigate(['/manage/entity-mgmt', entityId, 'profile']);
  }

  assignment: EntityAssignmentInformation = null;
  aStepNumber: number = 0;
  aIndexNumber: number = 0;
  @ViewChild(NgForm) assignmentForm: NgForm;
  submitAttempt: boolean = false;
  permissions: PDxListItem<PDxUserPermission>[] = PDxLists.PDxUserPermissions();

  permissionOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    selectMultiple: true,
  };

  assignUser(entityId: string): void {
    this.aStepNumber = 1;
    this.aIndexNumber = this.entityList.length - 1;
    this.assignment = new EntityAssignmentInformation();
    this.assignment.entityId = entityId;
    this.assignment.hierarchy = this.entityList.map(x => { return { value: x.entityId, text: x.name } });
  }

  private resetAssignment(): void {
    var entityId = this.assignment.entityId;
    this.assignment = null;
    setTimeout(() => {
      this.selectEntity(entityId, this.aIndexNumber);
    }, 50);
  }

  cancelAssignment(): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.resetAssignment();
  }

  nextStep(): void {
    this.secondaryAssignment = null;
    this.submitAttempt = false;
    switch (this.aStepNumber) {
      case 1: // select email address
        if (this.assignment.user.userId) {
          // picked an email address - move on to step 3
          this.aStepNumber = 3;
        } else {
          // typed an email address - get user info in step 2
          if (!this.assignmentForm.valid) {
            this.submitAttempt = true;
            return;
          }

          if ((this.searchedEmails.length == 1) && (this.searchedEmails[0].text == this.assignment.user.emailAddress)) {
            // was only one item in the list which matches what the user typed, but the user didn't select it
            this.getAssignment(this.searchedEmails[0].value, () => {
              this.nextStep();
            });
            return;
          } else {
            this.aStepNumber = 2;
            this.assignment.user.isActive = true;
            this.assignment.user.isPDxAdmin = false;
          }
        }
        break;
      case 2: // new user profile
      case 3: // set permissions
        if (!this.assignmentForm.valid) {
          this.submitAttempt = true;
          return;
        }
        this.aStepNumber++;
        break;
      default:
        this.aStepNumber++;
        break;
    }
  }

  previousStep(): void {
    switch (this.aStepNumber) {
      case 3: // pick permissions
        if (this.assignment.user.userId) { // picked an actual user - go to email address
          this.aStepNumber = 1;
          this.assignment.user = new UserInformation();
        } else {
          this.aStepNumber = 2;
        }
        break;
      case 4:
        // restrict other entities
        if (this.secondaryAssignment) {
          this.secondaryAssignment = null;
        } else {
          this.aStepNumber--;
        }
        break;
      default:
        this.aStepNumber--;
        break;
    }
  }

  searchedEmails: PDxListItem<string>[] = [];
  searchEmailAddress: OperatorFunction<string, readonly PDxListItem<string>[]> = (text$: Observable<string>) => {
    this.searchedEmails = [];
    return text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => { }),
      switchMap(term => {
        if (!term) {
          return of([]);
        }
        return from(this.ajax.MakeCall<PDxListItem<string>[]>('/User/Search', { query: term }, false)).pipe(
          map((x: PDxListItem<string>[]) => {
            this.searchedEmails = x;
            return x;
          }),
          catchError(() => {
            return of([]);
          }))
      }),
      tap(() => { }),
    )
  };

  formatter = (result: PDxListItem<string>) => result.text;

  getAssignment(userId: string, callback: () => any): void {
    this.ajax.MakeCall<EntityAssignmentInformation>('/User/GetAssignment', { userId: userId, entityId: this.assignment.entityId }).then((data) => {
      this.assignment = data;
      callback();
    }, () => { });
  }

  selectEmailAddress(ev: NgbTypeaheadSelectItemEvent<PDxListItem<string>>): void {
    this.getAssignment(ev.item.value, () => {
      this.nextStep();
    });
  }

  editSecondaryAssignment(): void {
    this.editSecondary = this.cloneService.deepClone(this.secondaryAssignment);
    this.aStepNumber = 5;
  }

  blacklistSecondary(): void {
    this.editSecondary.permissions = [];
    this.saveSecondary();
  }

  saveSecondary(): void {
    this.secondaryAssignment = this.cloneService.deepClone(this.editSecondary);
    this.secondaryAssignment.permissionDisplayList = this.permissions.filter(y => this.secondaryAssignment.permissions.filter(x => x == y.value).length > 0).map(x => x.text);
    var bFound = false;
    for (var i = 0; i < this.assignment.secondaryEntities.length; i++) {
      if (this.assignment.secondaryEntities[i].entityId == this.secondaryAssignment.entityId) {
        this.assignment.secondaryEntities[i] = this.cloneService.deepClone(this.secondaryAssignment);
        bFound = true;
      }
    }
    if (!bFound) {
      this.assignment.secondaryEntities.push(this.cloneService.deepClone(this.secondaryAssignment));
    }
    this.editSecondary = null;
    this.aStepNumber = 4;
  }

  isSecondaryEntity(entityId: string): boolean {
    if (this.assignment) {
      if (this.assignment.secondaryEntities.filter(x => x.entityId == entityId).length > 0) {
        return true;
      }
    }
    return false;
  }

  private copySecondary(header: EntityHeaderInformation, targetId: string): void {
    this.secondaryAssignment.entityId = targetId;
    this.secondaryAssignment.entityName = header.displayName;
    this.secondaryAssignment.fullAddress = header.fullAddress;
  }

  saveAssignment(): void {
    this.ajax.MakeCall<boolean>('/User/SaveAssignment', this.assignment).then((data) => {
      if (this.assignment.permissions.length > 0 && this.aIndexNumber > 0) {
        var meAsChild = this.entityList[this.aIndexNumber - 1].children.filter(x => x.entityId == this.assignment.entityId);
        if (meAsChild.length > 0) {
          meAsChild[0].hasUser = true; // set this to true for the sake of the dots, even though we're not reloading this column
        }
      }
      this.resetAssignment();
    }, () => { });
  }

  editSecondary: SecondaryEntityInformation = null;
  secondaryAssignment: SecondaryEntityInformation = null;
  loadSecondaryEntity(header: EntityHeaderInformation, targetId: string, entityId: string, idx: number): void {
    if (entityId == this.assignment.entityId) {
      this.secondaryAssignment = new SecondaryEntityInformation();
      this.copySecondary(header, targetId);

      if (this.assignment.passToChildren) {
        // use the actual permissions from the selected entity
        this.secondaryAssignment.permissionDisplayList = this.permissions.filter(y => this.assignment.permissions.filter(x => x == y.value).length > 0).map(x => x.text);
        this.secondaryAssignment.permissions = this.assignment.permissions;
      }
      return;
    }

    var overrides = this.assignment.secondaryEntities.filter(x => x.entityId == entityId);
    if (overrides.length > 0) {
      // use the here assignment from the UI
      if (overrides[0].passToChildren || (entityId == targetId)) {
        this.secondaryAssignment = this.cloneService.deepClone(overrides[0]);
      } else {
        this.secondaryAssignment = new SecondaryEntityInformation();
      }
      this.copySecondary(header, targetId);
    } else {
      this.ajax.MakeCall<SecondaryEntityInformation>('/User/GetHereAssignment', { userId: this.assignment.user.userId, entityId: entityId }).then((data) => {
        if (data) {
          if (targetId == entityId) {
            // use the here assignment from the database
            this.secondaryAssignment = data;
            this.copySecondary(header, targetId);
          } else if (data.passToChildren) {
            // use the here assignment as an inherited property
            this.secondaryAssignment = data;
            this.copySecondary(header, targetId);
          } else {
            // start with no permissions
            this.secondaryAssignment = new SecondaryEntityInformation();
            this.copySecondary(header, targetId);
          }
        } else {
          // check the parent
          this.loadSecondaryEntity(header, targetId, this.entityList[idx - 1].entityId, idx - 1);
        }
      }, () => { });
    }
  }

  selectEntity(entityId: string, idx: number, changeUrl: boolean = true): void {
    if (this.assignment) {
      if ((this.aStepNumber >= 4) && (idx > this.aIndexNumber)) {
        this.editSecondary = null;
        this.ajax.MakeCall<EntityHeaderInformation>('/Entity/Header', { entityId: entityId }).then((data) => {
          this.loadSecondaryEntity(data, entityId, entityId, idx);
        }, () => { });
      } else {
        return;
      }
      changeUrl = false;
    } else {
      if (!this.dirtyService.isClean()) {
        return;
      }
      this.newAccount = null;
      this.selectionPath.splice(0, 1);
    }

    this.entityList.splice(idx);
    this.ajax.MakeCall<EntityTreeInformation>('/Entity/TreeChildren', { parentId: entityId }).then((data) => {
      this.entityList.push(data);
      while (this.entityList.length > this.columnFilters.length) {
        this.columnFilters.push(new IntreeEntityFilter());
      }

      if ((this.selectionPath.length > 0) && (data.children.filter((x) => x.entityId == this.selectionPath[0]).length > 0)) {
        this.selectEntity(this.selectionPath[0], idx + 1);
      } else if (changeUrl) {
        var pathArray = ['/manage/entities'];
        pathArray.push(...this.entityList.map(x => x.entityId));
        var url = this.router.createUrlTree(pathArray).toString();
        this.location.go(url);
      }

      setTimeout(() => {
        var scrollElem = document.querySelector('.last-column');
        scrollElem.scrollIntoView({ inline: 'end', block: 'start' });
      }, 50)
    }, () => { });
  }

  clearAccount(): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.newAccount = null;
    this.entityList = [];
    var url = this.router.createUrlTree(['/manage/entities']).toString();
    this.location.go(url);
  }

  refreshEntities(parentId: string): void {
    this.ajax.MakeCall<EntityTreeInformation>('/Entity/TreeChildren', { parentId: parentId }).then((data) => {
      var entity = this.entityList.findIndex((x) => { return x.entityId == parentId });
      if (entity >= 0) {
        this.entityList[entity] = data;
        if (entity > 0) {
          this.entityList[entity - 1].children.forEach((x) => {
            if (x.entityId == parentId) {
              x.childCount = data.children.length;
            }
          })
        }
      }
    }, () => { });
  }

  launchEntity(): void {
    this.confirmService.confirm('Launch Entity', 'Are you sure you want to launch this entity?', 'Launch Entity').then(() => {
      this.ajax.MakeCall<boolean>('/Entity/Launch', { entityId: this.entityList[this.entityList.length - 1].entityId }).then((data) => {
        this.entityList[this.entityList.length - 1].isLaunched = data;
        if (this.entityList.length > 1) {
          this.entityList[this.entityList.length - 2].children.filter((x) => x.entityId == this.entityList[this.entityList.length - 1].entityId).forEach((x) => {
            x.isLaunched = data;
          })
        }
      }, () => { });
    }, () => { });
  }

  /***************
  ** search tab **
  ***************/
  showSearch: boolean = false;
  entityResults: DataTablesResponse<EntityHeaderInformation>;
  searchFilter: FullSearchFilter;

  resetSearchFilters(): void {
    this.searchFilter = new FullSearchFilter(10, '', '');
    this.searchFilter.entityStatus = this.entityStatuses.filter(x => x.value === true)[0];
    this.searchFilter.launchStatus = this.launchStatuses[0];
    this.showSearch = false;
  }

  showTheList(): void {
    if (!this.showSearch) {
      this.loadSearchList(true);
    }
  }

  loadSearchList = (reset: boolean = false) => {
    if (reset) {
      this.searchFilter.page = 1;
    }
    this.ajax.MakeCall<DataTablesResponse<EntityHeaderInformation>>('/Entity/SearchList', this.searchFilter).then(results => {
      this.entityResults = results;
      this.showSearch = true;
    }, () => { console.log('error'); });
  }

  inputFieldChange(ev: KeyboardEvent): void {
    if (ev.key == 'Enter') {
      this.showTheList();
    }
  }

  hideTheList(): void {
    this.showSearch = false;
  }

  showInTree(entity: EntityHeaderInformation, idx: number): void {
    this.activeTab = 'tree';

    this.selectionPath = [];
    this.selectionPath.push(...entity.hierarchy.map(x => x.value));
    this.selectionPath.push(entity.entityId);
    this.selectionPath.splice(idx + 1);
    this.selectEntity(this.selectionPath[0], 0);

  }
}

class FullSearchFilter extends ListFilter {
  constructor(p: number, col: string, dir: string) {
    super(p, col, dir);
    this.state = null;
  }
  hasMaster: boolean;
  hasFormulary: boolean;
  hasVendor: boolean;
  hasBill: boolean;
  hasShip: boolean;
  hasUser: boolean;
  entityStatus: PDxListItem<boolean>;
  launchStatus: PDxListItem<boolean>;
  state: string;
  keywords: string;
  vendorId: string;
  accountId: string;
}

class IntreeEntityFilter {
  constructor() {
    this.inSearch = false;
    this.searchText = null;
  }
  inSearch: boolean;
  searchText: string;
}

class IntreeAccountSearchFilter {
  constructor() {
    this.vendorId = null;
  }
  accountName: string;
  hasMaster: boolean;
  hasFormulary: boolean;
  hasVendor: boolean;
  hasBill: boolean;
  hasShip: boolean;
  hasUser: boolean;
  entityStatus: PDxListItem<boolean>;
  launchStatus: PDxListItem<boolean>;
  vendorId: string;
}

class NewAccountInfo {
  entityId: string;
  parentId: string;
}